

import {Component, OnInit, Input, Output, EventEmitter, ElementRef} from '@angular/core';
import {Http} from '@angular/http';
import {SharedService} from '../shared/shared.service';
import * as Materialize from 'angular2-materialize';
import { UtilsService } from '../shared/utils.service';

/// <reference path="./dropzone.d.ts"/>
declare var jQuery: any;
@Component({
    selector: 'dropzone',
    template: `<div id="previews1" class="dropzone needsclick dz-clickable dz-started"><div id="dropzoneback" class="dropzone-customback"></div></div>`
})

/*Dropzone for file uploads*/
export class DropzoneComponent implements OnInit{

    private _dropzone: Dropzone;
    _service: any;
    @Input()
    element: string = '.dropzoneArea';

    @Input()
    url: string = 'file/post';

    @Input()
    uploadMultiple: boolean = false;

    @Input()
    maxFileSize: number = 50;

    @Input()
    clickable: string = '.dropzoneArea';

    @Input()
    autoProcessQueue: boolean = true;

    @Input()
    addRemoveLinks: boolean = true;

    @Input()
    createImageThumbnails: boolean = true;

    @Input()
    previewTemplate: string = '<div class="dz-preview dz-file-preview"><div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div><div class="dz-size" data-dz-size></div><img data-dz-thumbnail /></div><div class="dz-success-mark"><span>?</span></div><div class="dz-error-mark"><span>?</span></div></div>';
// <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>
    @Input()
    acceptedFiles: string = '*';

    @Output()
    sending: EventEmitter<boolean>;

    @Output()
    uploadprogress: EventEmitter<number>;

    @Output()
    success: EventEmitter<any>;

    @Output()
    error: EventEmitter<any>;

    @Output()
    projectInputChanged: EventEmitter<any>;

    @Output()
    dropzoneEmpty: EventEmitter<any>;

    constructor(private _eleRef: ElementRef, private _http: Http, private service: SharedService, private utilsService: UtilsService){

        this.sending = new EventEmitter<boolean>();
        this.uploadprogress = new EventEmitter<number>();
        this.success = new EventEmitter<any>();
        this.error = new EventEmitter<any>();
        this.projectInputChanged = new EventEmitter<any>();
        this.dropzoneEmpty = new EventEmitter<any>();
        this._service = service;
        console.log('SERVICE:', service);
        // this.initDropzone();
    }

    initDropzone(){

            this._dropzone = new Dropzone('div#previews1', {
                url: this.url,
                uploadMultiple: this.uploadMultiple,
                maxFilesize: this.maxFileSize,
                clickable: true,
                autoProcessQueue: this.autoProcessQueue,
                addRemoveLinks: this.addRemoveLinks,
                createImageThumbnails: this.createImageThumbnails,
                previewTemplate: this.previewTemplate,
                maxFiles: 1
            });


            this._dropzone.on('sending', (file, xhr, formaData) => {
                this.sending.emit(true);
            });

            this._dropzone.on('uploadprogress', (file, progress, bytesSent) => {
                this.uploadprogress.emit(progress);
            });

            this._dropzone.on('success', (file) => {
                // this.success.emit(file);
            });

            this._dropzone.on('error', (file, message) => {
                // this.error.emit(message);
            });
            this._dropzone.on('addedfile', (file, message) => {
              let type = this.utilsService.determineModelType(file.name);
              let fileparts = file.name.split('.');
              let ext = fileparts.pop();
              let filenameWithoutExt = fileparts;
              if (this._dropzone.files.length > 1)
              {
                this._dropzone.removeAllFiles();
                Materialize.toast('Can not upload more than one file', 3000);
                return;
              }

              /*if(type === 0){
                var element = document.getElementById("dropzoneback");
                element.parentNode.removeChild(element);
                this._dropzone.removeFile(file);
                Materialize.toast('Selected file format "'+ ext +'" is not supported as a primary CAD model.', 4000);
                return;
              }*/

            if (file.size > 50000000)
            {
              let element = document.getElementById('dropzoneback');
              element.parentNode.removeChild(element);
              this._dropzone.removeFile(file);
              Materialize.toast('File is too big ' + Math.round(file.size / 1024 / 1024) + 'MB. Max file size is: 50MB.', 4000);
              return;
            }

            if (this._dropzone.files.length === 1)
              {
                $('input[name=projectname]').val(fileparts[0]);
                $('#partnumber').attr('value', fileparts[0]);
                $('input[name=partnumber]').val(fileparts[0]);
                $('#projectname').change();
                $('#partnumber').change();
                this.projectInputChanged.emit({
                  projectname: fileparts[0],
                  partnumber: fileparts[0],
                  filename: file.name
                });
                this._service.setFileAttached(file);
                // $("#previews1").css('background-image', 'none');
                let element = document.getElementById('dropzoneback');
                element.parentNode.removeChild(element);
              }
            });

            this._dropzone.on('removedfile', (file, message) => {
              if (this._dropzone.files.length === 0)
              {
                $('#projectname').val('');
                $('#partnumber').val('');
                $('#revision').val('');
                $('#projectdescription').val('');
                $('#customername').val('');
                $('#projectname').change();
                $('#partnumber').change();
                $('#revision').change();
                $('#projectdescription').change();
                $('#customername').change();
                this.projectInputChanged.emit({
                  projectname: null,
                  partnumber: null,
                  revision: null
                });

                this.dropzoneEmpty.emit();
                this._service.setFileAttached(null);
                $('#previews1').append( '<div id="dropzoneback" class="dropzone-customback"></div>' );
              }
            });

            this._dropzone.on('maxfilesexceeded', (file) => {
                this._dropzone.removeFile(file);
                Materialize.toast('A project can only have one primary CAD model', 3000);
            });
    }

    ngOnInit(){
        this.initDropzone();
    }

  setSelectedIndex(s, valsearch)
  {
  // Loop through all the items in drop down list
    for (let i = 0; i < s.options.length; i++)
    {
      if (s.options[i].value == valsearch)
      {
        // Item is found. Set its property and exit
        s.options[i].selected = true;
        break;
      }
    }
   return;
  }


  clearMe(){
    console.log('clear me');
    this._dropzone.removeAllFiles();
    $('#projectname').val('');
    $('#partnumber').val('');
    $('#revision').val('');
    $('#projectdescription').val('');
    $('#customername').val('');
    $('#projectname').change();
    $('#partnumber').change();
    $('#revision').change();
    $('#projectdescription').change();
    $('#customername').change();
    // $('#Select_material').selectedIndex = "" ;
    // this.setSelectedIndex(document.getElementById("Assignee"),"");
    // this.setSelectedIndex(document.getElementById("Select_material"),"");
    this.dropzoneEmpty.emit();
  }






}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/dropzone/dropzone.component.ts